module.exports = __webpack_public_path__ + "static/media/icon-simple-check.4db4903c.svg";